var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReSubscribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.2977 3.4164C48.1016 1.37925 51.8984 1.37926 54.7023 3.41641L92.8505 31.1327C95.6544 33.1699 96.8277 36.7808 95.7567 40.077L81.1854 84.923C80.1144 88.2192 77.0427 90.4509 73.5769 90.4509H26.4231C22.9573 90.4509 19.8856 88.2192 18.8146 84.923L4.24328 40.077C3.17229 36.7808 4.34556 33.1699 7.14946 31.1327L45.2977 3.4164Z",
    fill: "url(#paint0_linear_637_13703)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_637_13703)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3571 33.5C45.4617 33.5 46.3571 34.3954 46.3571 35.5V45.2332C46.3571 46.3378 45.4617 47.2332 44.3571 47.2332C43.2526 47.2332 42.3571 46.3378 42.3571 45.2332V35.5C42.3571 34.3954 43.2526 33.5 44.3571 33.5ZM61.3571 66.6429C60.2526 66.6429 59.3571 65.7474 59.3571 64.6429C59.3571 62.2749 58.4165 60.0038 56.742 58.3294C55.0676 56.655 52.7966 55.7143 50.4286 55.7143C48.0606 55.7143 45.7895 56.655 44.1151 58.3294C42.4407 60.0038 41.5 62.2749 41.5 64.6429C41.5 65.7474 40.6046 66.6429 39.5 66.6429C38.3954 66.6429 37.5 65.7474 37.5 64.6429C37.5 61.214 38.8621 57.9256 41.2867 55.501C43.7113 53.0764 46.9997 51.7143 50.4286 51.7143C53.8574 51.7143 57.1459 53.0764 59.5705 55.501C61.995 57.9256 63.3571 61.214 63.3571 64.6429C63.3571 65.7474 62.4617 66.6429 61.3571 66.6429ZM58.5 35.5C58.5 34.3954 57.6046 33.5 56.5 33.5C55.3954 33.5 54.5 34.3954 54.5 35.5V45.2332C54.5 46.3378 55.3954 47.2332 56.5 47.2332C57.6046 47.2332 58.5 46.3378 58.5 45.2332V35.5Z",
    fill: "#4D4C4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_637_13703",
    x: 37.5,
    y: 33.5,
    width: 25.8574,
    height: 37.1429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_637_13703"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_637_13703",
    x1: 94.1667,
    y1: 32.5,
    x2: 9.16667,
    y2: 59.5833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229637,
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529331,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711591,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606060"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReSubscribe);
export default __webpack_public_path__ + "static/media/reSubscribe.3ae6349f90f35c059454f49d31d0aae9.svg";
export { ForwardRef as ReactComponent };